import { Component, EventEmitter, Output } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { MixpanelService } from '@core/services';
import { TranslateModule } from '@ngx-translate/core';
import { AppRoutes } from '@shared/helpers';
import { TrapFocusDirective } from '../../../shared/directives/trap-focus.directive';

@Component({
    selector: 'app-menu-support[closePopover]',
    templateUrl: './menu-support.component.html',
    styleUrls: ['./menu-support.component.scss'],
    standalone: true,
    imports: [TrapFocusDirective, TranslateModule],
})
export class MenuSupportComponent {
    @Output() closePopover: EventEmitter<void> = new EventEmitter<void>();

    readonly supportHubUrl = 'https://www.transnetyx.com/support';
    readonly termsOfUseUrl = 'https://info.transnetyx.com/hubfs/Transnetyx%20Terms%20of%20Use.pdf';
    titlePage: string = '';

    constructor(
        private mixpanelService: MixpanelService,
        private router: Router,
        private titleService: Title
    ) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                if (event.url === AppRoutes.routes().DASHBOARD) {
                    this.titlePage = 'Sequencing - Dashboard';
                } else {
                    this.titlePage = this.titleService.getTitle();
                }
            }
        });
    }

    close(): void {
        this.closePopover.emit();
    }

    openChat(): void {
        this.logHelpAndSupportTag('Live Chat');
        // @ts-ignore
        window['happyFoxChat'].showWidget();
        // @ts-ignore
        window['happyFoxChat'].expandChatbox();
        this.close();
    }

    logHelpAndSupportTag(eventName: string): void {
        this.mixpanelService.logHelpAndSupportClick(eventName, this.titlePage);
    }
}
